import React from 'react'
import DataTable from './DataTable'
import useTranslation from '../../shared/TranslationProvider'

const Page = () => {
  const { t } = useTranslation()
  const addAlert = t('Page.add_job_alert')
  const subheading = t('DataTable.subheading', { add_alert: addAlert })
  return (
    <div className="flex min-h-[67vh] flex-col gap-4">
      <div className="">
        <h1>
          <span className="font-normal">{t('header_span')}</span>{' '}
          {t('header_bold')}
        </h1>
        <p>{subheading}</p>
      </div>
      <DataTable />
    </div>
  )
}

export default Page
